{
  "hangarsPresenter": {
    "title": "Hangars – {{fboName}}",
    "stats": {
      "totalHangars": "Total Hangars",
      "totalAircraft": "Total Aircraft in Hangars"
    },
    "columns": {
      "hangarName": "Hangar Name",
      "aircraft": "Aircraft",
      "utilization": "Utilization",
      "estValue": "Est. Value",
      "estTowTime": "Est. Tow Time",
      "lastStacked": "Last Stacked",
      "actions": "Actions"
    },
    "tooltips": {
      "aircraftCount": "# aircraft inside hangar / # aircraft wanted inside",
      "utilization": {
        "title": "Utilization",
        "stacked": "<strong>Stacked</strong> shows current utilization, which can exceed 100% when aircraft are parked in the negative space of other aircraft footprints.",
        "fullLoad": "<strong>At full tenant load</strong> shows what utilization would be if every aircraft assigned to this hangar were on the ground at once.",
        "gauge": "The gauge shows a baseline marker at 100% - blue below, green above.",
        "adjust": "Adjust how this is calculated in Settings → Configuration"
      },
      "estValue": "Estimated value of the hangar per night based on aircraft fully inside the hangar",
      "estValueBreakdown": "Base: ${{base}} | Trans: ${{transient}}",
      "estTowTime": "Estimated time to tow hangar into position"
    },
    "emptyState": {
      "title": "No Hangars Yet",
      "description": "Create your first hangar to start managing aircraft storage and stacking operations."
    }
  },
  "utilizationDisplay": {
    "stacked": "stacked",
    "atFullTenantLoad": "at full tenant load"
  },
  "multiHangarSelector": {
    "label": "Select Hangars",
    "selectAll": "Select All",
    "goButton": "Go",
    "noHangars": {
      "primary": "No hangars available",
      "secondary": "Create a hangar first to use this feature"
    }
  },
  "hangarRow": {
    "aircraftCount": "{{inside}} / {{total}} aircraft",
    "lastStacked": {
      "tooltip": "Date of last stack operation",
      "never": "Never"
    },
    "buttons": {
      "currentHangar": "Current Hangar",
      "hangarSchedule": "Hangar Schedule",
      "editTenants": "Edit Tenants"
    }
  }
}
